define([], function () {
    var framework = {
        "clientIpInvalid.helpUrl": "/pt-br/usermanual-iam/iam_07_0003.html",
    };

    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
})


// WEBPACK FOOTER //
// ./public/hws/i18n/pt-br/resourcehk.js